import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [contentFlags, setContentFlags] = useState({});

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const checkContent = async () => {
      try {
        const [testimonials, blogs, newsletters, portfolio] = await Promise.all([
          axios.get(`${API}/testimonials/approved`).then(r => r.data?.length > 0).catch(() => false),
          axios.get(`${API}/blog`).then(r => r.data?.length > 0).catch(() => false),
          axios.get(`${API}/newsletter-archive`).then(r => r.data?.length > 0).catch(() => false),
          axios.get(`${API}/portfolio`).then(r => r.data?.length > 0).catch(() => false),
        ]);
        setContentFlags({ referenzen: testimonials, blog: blogs, newsletter: newsletters, portfolio });
      } catch {}
    };
    checkContent();
  }, []);

  const allLinks = [
    { href: "/leistungen", label: "Leistungen", isPage: true },
    { href: "/portfolio", label: "Portfolio", isPage: true, contentKey: "portfolio" },
    { href: "/ueber-uns", label: "Über uns", isPage: true },
    { href: "/termin", label: "Termin", isPage: true },
    { href: "/referenzen", label: "Referenzen", isPage: true, contentKey: "referenzen" },
    { href: "/fallstudien", label: "Fallstudien", isPage: true },
    { href: "/roi-rechner", label: "ROI-Rechner", isPage: true },
    { href: "/blog", label: "Blog", isPage: true, contentKey: "blog" },
    { href: "/portal", label: "Kundenportal", isPage: true },
  ];

  const navLinks = allLinks.filter(link => !link.contentKey || contentFlags[link.contentKey]);

  const handleNavClick = (link) => {
    if (link.isPage) {
      window.location.href = link.href;
    } else {
      scrollToSection(link.href);
    }
  };


  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? "nav-glass shadow-sm" : "bg-transparent"}`
      }
      data-testid="navigation">

      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <nav className="flex items-center justify-between h-20">
          {/* Logo */}
          <a
            href="/"
            className={`font-playfair text-2xl font-semibold tracking-tight transition-colors duration-300 ${isScrolled ? "text-lab-primary" : "text-white"}`}
            data-testid="nav-logo">LAB336
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) =>
            <button
              key={link.href}
              onClick={() => handleNavClick(link)}
              className={`font-medium text-sm tracking-wide transition-colors duration-200 ${isScrolled ? "text-lab-text-muted hover:text-lab-primary" : "text-white/70 hover:text-white"} ${link.isPage ? "flex items-center gap-1" : ""}`}
              data-testid={`nav-link-${link.href.replace(/^[#/]/, '')}`}>

                {link.label}
              </button>
            )}
            <button
              onClick={() => window.location.href = "/kontakt"}
              className="btn-primary rounded-none text-sm"
              data-testid="nav-contact-btn">

              Kontakt
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-lab-primary relative z-[60]"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            data-testid="mobile-menu-toggle">

            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </nav>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMobileMenuOpen &&
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
          className="md:hidden nav-glass border-t border-lab-border"
          data-testid="mobile-menu">

            <div className="px-6 py-6 space-y-4">
              {navLinks.map((link) =>
            <button
              key={link.href}
              onClick={() => handleNavClick(link)}
              className="block w-full text-left text-lab-text hover:text-lab-accent font-medium py-2 transition-colors duration-200">

                  {link.label}
                </button>
            )}
              <button
              onClick={() => window.location.href = "/kontakt"}
              className="btn-secondary rounded-none w-full text-center mt-4">

                Kontakt
              </button>
            </div>
          </motion.div>
        }
      </AnimatePresence>
    </header>);

};

export default Navigation;